(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutte-discount-teaser"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-tutte-welcome]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const openButton = root.querySelector('[data-tutte-welcome-open]');
    const rating = document.querySelector('.tutte-google-rating');
    let formsRoot;
    let formsObserver;

    const positionCoupon = () => {
      if (!openButton) return;
      if (!rating?.isConnected || !rating.getClientRects().length) {
        openButton.style.removeProperty('--tutte-coupon-bottom');
        return;
      }

      const ratingBottom = parseFloat(window.getComputedStyle(rating).bottom) || 0;
      openButton.style.setProperty(
        '--tutte-coupon-bottom',
        `${Math.ceil(ratingBottom + rating.getBoundingClientRect().height + 20)}px`
      );
    };

    const syncShopifyForms = () => {
      const host = document.querySelector('shopify-forms-embed');
      const shadowRoot = host?.shadowRoot;
      if (!shadowRoot) return false;

      if (!shadowRoot.querySelector('#tutte-shopify-forms-bridge')) {
        const style = document.createElement('style');
        style.id = 'tutte-shopify-forms-bridge';
        style.textContent = '#app-embed[data-current-step="tease"]{visibility:hidden!important;pointer-events:none!important;}';
        shadowRoot.appendChild(style);
      }

      formsRoot = shadowRoot.querySelector('#app-embed');
      const isOpen = formsRoot?.dataset.currentStep !== 'tease';
      openButton?.setAttribute('aria-expanded', String(Boolean(isOpen)));

      if (!formsObserver) {
        formsObserver = new MutationObserver(syncShopifyForms);
        formsObserver.observe(shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-current-step']
        });
      }

      return true;
    };

    const openShopifyForm = () => {
      if (!syncShopifyForms()) return false;

      if (formsRoot?.dataset.currentStep !== 'tease') return true;
      const teaser = formsRoot.querySelector('button');
      if (!teaser) return false;

      teaser.click();
      return true;
    };

    openButton?.addEventListener('click', () => {
      if (openShopifyForm()) return;

      let attempts = 0;
      const waitForForms = window.setInterval(() => {
        attempts += 1;
        if (openShopifyForm() || attempts >= 20) window.clearInterval(waitForForms);
      }, 150);
    });

    positionCoupon();
    syncShopifyForms();
    window.addEventListener('resize', positionCoupon, { passive: true });
    window.visualViewport?.addEventListener('resize', positionCoupon, { passive: true });

    if (rating && 'ResizeObserver' in window) {
      const ratingObserver = new ResizeObserver(positionCoupon);
      ratingObserver.observe(rating);
    }

    const formsReadyTimer = window.setInterval(() => {
      if (syncShopifyForms()) window.clearInterval(formsReadyTimer);
    }, 250);
    window.setTimeout(() => window.clearInterval(formsReadyTimer), 15000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutte-featured-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tutte-review-carousel')) {
    customElements.define('tutte-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.previous = this.querySelector('[data-carousel-previous]');
        this.next = this.querySelector('[data-carousel-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        new ResizeObserver(() => this.update()).observe(this.track);
        this.update();
      }
      move(direction) {
        const card = this.track.querySelector('.tutte-reviews__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth - 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutte-google-rating"] && !Shopify.designMode) return;
  try {
    
  function initializeTutteRatings() {
    document.querySelectorAll('.tutte-google-rating').forEach(function(badge) {
      if (badge.dataset.tutteInitialized) return;
      badge.dataset.tutteInitialized = 'true';
      function minimize() {
        if (!badge.isConnected) return;
        if (badge.contains(document.activeElement)) {
          badge.addEventListener('focusout', function() {
            setTimeout(minimize, 0);
          }, { once: true });
          return;
        }
        badge.classList.add('is-minimized');
      }
      setTimeout(minimize, 5000);
    });
  }

  function closeTutteGoogleDialog(dialog) {
    if (!dialog) return;
    dialog.hidden = true;
    document.body.classList.remove('tutte-google-dialog-open');
    var badge = document.querySelector('[aria-controls="' + dialog.id + '"]');
    if (badge) {
      badge.setAttribute('aria-expanded', 'false');
      badge.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTutteRatings, { once: true });
  } else {
    initializeTutteRatings();
  }

  document.addEventListener('shopify:section:load', initializeTutteRatings);

  document.addEventListener('click', function(event) {
    var opener = event.target.closest('[data-tutte-rating-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog) {
        dialog.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        document.body.classList.add('tutte-google-dialog-open');
        var closeButton = dialog.querySelector('[data-tutte-rating-close]');
        if (closeButton) closeButton.focus();
      }
      return;
    }

    var close = event.target.closest('[data-tutte-rating-close]');
    if (close) {
      closeTutteGoogleDialog(close.closest('[data-tutte-rating-dialog]'));
      return;
    }

    var dismiss = event.target.closest('[data-tutte-rating-dismiss]');
    if (dismiss) dismiss.closest('.tutte-google-rating').remove();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    var dialog = document.querySelector('[data-tutte-rating-dialog]:not([hidden])');
    closeTutteGoogleDialog(dialog);
  });

  } catch(e) { console.error(e); }
})();
})();
